export function HorizontalDots({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.91667 5.8335C2.275 5.8335 1.75 6.3585 1.75 7.00016C1.75 7.64183 2.275 8.16683 2.91667 8.16683C3.55833 8.16683 4.08333 7.64183 4.08333 7.00016C4.08333 6.3585 3.55833 5.8335 2.91667 5.8335Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M11.0833 5.8335C10.4417 5.8335 9.91667 6.3585 9.91667 7.00016C9.91667 7.64183 10.4417 8.16683 11.0833 8.16683C11.725 8.16683 12.25 7.64183 12.25 7.00016C12.25 6.3585 11.725 5.8335 11.0833 5.8335Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M7 5.8335C6.35833 5.8335 5.83333 6.3585 5.83333 7.00016C5.83333 7.64183 6.35833 8.16683 7 8.16683C7.64167 8.16683 8.16667 7.64183 8.16667 7.00016C8.16667 6.3585 7.64167 5.8335 7 5.8335Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M2.91667 5.8335C2.275 5.8335 1.75 6.3585 1.75 7.00016C1.75 7.64183 2.275 8.16683 2.91667 8.16683C3.55833 8.16683 4.08333 7.64183 4.08333 7.00016C4.08333 6.3585 3.55833 5.8335 2.91667 5.8335Z"
          stroke="var(--clr-general-primary)"
        />
        <path
          d="M11.0833 5.8335C10.4417 5.8335 9.91667 6.3585 9.91667 7.00016C9.91667 7.64183 10.4417 8.16683 11.0833 8.16683C11.725 8.16683 12.25 7.64183 12.25 7.00016C12.25 6.3585 11.725 5.8335 11.0833 5.8335Z"
          stroke="var(--clr-general-primary)"
        />
        <path
          d="M7 5.8335C6.35833 5.8335 5.83333 6.3585 5.83333 7.00016C5.83333 7.64183 6.35833 8.16683 7 8.16683C7.64167 8.16683 8.16667 7.64183 8.16667 7.00016C8.16667 6.3585 7.64167 5.8335 7 5.8335Z"
          stroke="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
